/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

const FormSubmitSuccess = ({ messages }) => {
    return (
        <div className="form-success">
            {messages.map(({ message }, key) => {
                return <p key={key}>{message}</p>;
            })}
            <style jsx>
                {`
                    .form-success {
                        max-width: 460px;
                        margin-bottom: 10px;
                        border: 1px solid rgb(0, 152, 45);
                        line-height: 21px;
                        background-color: rgba(0, 152, 45, 0.15);
                    }
                    p {
                        font-size: 0.9em;
                    }
                `}
            </style>
        </div>
    );
};

FormSubmitSuccess.propTypes = {
    messages: PropTypes.array.isRequired,
};

export default FormSubmitSuccess;
